export const CheckSpaceRoleService = Symbol.for('CheckSpaceRoleService');
